import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import GlobalSelectFieldWithoutFormikNew from '../../../../../components/mui/GlobalSelectFieldWithoutFormikNew';
import { useMemo, useState } from 'react';
// import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { deleteTrainerSlot, getTrainerSlot, updateTrainerSlot } from '../../../../../redux/features/CRDslice';
import useHandleApiResponse from '../../../../../Hooks/useHandleApiResponse';
import { useSelector } from 'react-redux';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import GlobalDeleteDialogueContent from '../../../../../components/GlobalDeleteDialogueContent';

export default function EditUpdateSlot({ row, setOpen, setUseEffectReloading }) {
  const [timeInterval, setTimeInterval] = useState({ id: '', value: '' });
  const [from_time, setFromTime] = useState(null);
  const [to_time, setToTime] = useState(null);
  const dispatch = useDispatch();
  const apiHelper = useHandleApiResponse();
  const [deletePopup, setDeletePopUp] = useState(false);
  const submitLoading = useSelector((state) => state.crd.submitLoading);
  const deleteLoading = useSelector((state) => state.crd.deleteLoading);

  const existingSlots = useMemo(() => {
    const slots = row?.slots ?? [];
    return slots?.map((value) => ({
      id: value?.trainer_slot_id,
      label: `${value?.from_time?.slice(0, 5)} - ${value?.to_time?.slice(0, 5)}`,
    }));
  }, [row]);

  const submitHandler = () => {
    if (!Boolean(timeInterval?.id) || !Boolean(from_time) || !Boolean(to_time)) return;

    const data = {
      trainer_slot_id: timeInterval?.id,
      from_time,
      to_time,
    };

    dispatch(updateTrainerSlot(data)).then((res) =>
      apiHelper(res, {
        onSuccess: () => {
          setOpen(false);
          dispatch(getTrainerSlot(row?.trainer_id));
          setUseEffectReloading((prev) => !prev);
        },
      }),
    );
  };

  return (
    <Stack gap={2}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <GlobalSelectFieldWithoutFormikNew
          label={'Existing Time Slots'}
          data={existingSlots}
          setChange={setTimeInterval}
          selectedDetails={timeInterval}
          keys={{
            itemId: 'id',
            itemValue: 'label',
          }}
        />
        <Divider />
        <TimePicker
          label={'From'}
          views={['hours', 'minutes']}
          format="HH:mm"
          ampm={false}
          disabled={!timeInterval.id}
          value={from_time ? dayjs(from_time, 'HH:mm') : null}
          onChange={(v) => setFromTime(v ? v.format('HH:mm') : null)}
        />
        <TimePicker
          label={'To'}
          views={['hours', 'minutes']}
          format="HH:mm"
          ampm={false}
          disabled={!timeInterval.id}
          value={to_time ? dayjs(to_time, 'HH:mm') : null}
          onChange={(v) => setToTime(v ? v.format('HH:mm') : null)}
        />
      </LocalizationProvider>
      <Stack direction={'row'} width={'100%'} justifyContent={'space-between'}>
        <Button
          variant="outlined"
          color="error"
          onClick={() => setDeletePopUp(true)}
          disabled={!timeInterval?.id || submitLoading}
        >
          {deleteLoading ? `Deleting...` : `Delete`}
        </Button>

        <Button
          variant="outlined"
          color="primary"
          onClick={submitHandler}
          disabled={!timeInterval?.id || submitLoading}
        >
          {submitLoading ? `Submitting...` : `Submit`}
        </Button>
      </Stack>
      {deletePopup && (
        <GlobalDialog
          title={'Delete Time Slot'}
          open={deletePopup}
          setOpen={setDeletePopUp}
          content={
            <GlobalDeleteDialogueContent
              cancel={true}
              content={`Are you sure to delete this ${timeInterval?.value} slot ?`}
              loading={deleteLoading}
              setOpen={setDeletePopUp}
              deleteDispatchParams={{ trainer_slot_id: timeInterval?.id }}
              dispatchDeleteFn={timeInterval?.id ? deleteTrainerSlot : () => {}}
              onSuccess={() => {
                setUseEffectReloading((prev) => !prev);
                dispatch(getTrainerSlot(row?.trainer_id));
                setOpen(false);
              }}
            />
          }
        />
      )}
    </Stack>
  );
}
